import * as amplitude from "@amplitude/analytics-browser";

/**
 * Support inbox version for a route, or undefined when it isn't the inbox. V2
 * (`/support-v2`) is checked first since it also contains the `support` substring.
 */
export function supportVersionForPath(
  pathname: string,
): "v1" | "v2" | undefined {
  if (/\/support-v2(\/|$)/.test(pathname)) {
    return "v2";
  }
  if (/\/support(\/|$)/.test(pathname)) {
    return "v1";
  }
  return undefined;
}

/**
 * Amplitude enrichment plugin stamping every support-inbox event with a
 * `supportVersion` property so Support V1 and V2 can be compared cleanly.
 */
export function supportVersionAmplitudePlugin(): Parameters<
  typeof amplitude.add
>[0] {
  return {
    name: "support-version-enrichment",
    type: "enrichment",
    setup: async () => undefined,
    execute: async (event) => {
      const supportVersion = supportVersionForPath(window.location.pathname);
      if (supportVersion) {
        event.event_properties = { ...event.event_properties, supportVersion };
      }
      return event;
    },
  };
}
